import { Link } from 'gatsby'
import { useState, useEffect } from 'react'
import { Collapse, Navbar, NavbarToggler, NavbarBrand } from 'reactstrap'
import { Trans } from 'gatsby-plugin-react-i18next'
import HelloBarFr from '../HellobarFr'

const HeaderFr = ({
  site,
  langSelected,
  toggleNavbar1,
  t,
  cssDisplay,
  selectLangList,
  languages,
  collapsed1,
  showDropdown,
}) => {
  const [currentUrl, setCurrentUrl] = useState('')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.pathname)
    }
  }, [])

  // commenting out the onClikc event for the dropdown menu on webpages
  // const [isRenderedMenu, setIsRenderedMenu] = useState(false)

  // useEffect(() => {
  //   setIsRenderedMenu(true)
  // })

  // useEffect(() => {
  //   const getSolutionMenu = document.querySelector('.listingMenu .dropdownmenu.solutions')
  //   const getFeatMenu = document.querySelector('.listingMenu .dropdownmenu.feat')
  //   const getResourcesMenu = document.querySelector('.listingMenu .dropdownmenu.resources-menu')
  //   const dropDownMenuSolution = document.querySelector('.listingMenu.solution-menu__item')
  //   const dropDownMenuFeature = document.querySelector('.listingMenu.feature-menu__item')
  //   const dropDownMenuResources = document.querySelector('.listingMenu.resource-menu__item')

  //   // console.log(
  //   //   getSolutionMenu,
  //   //   getFeatMenu,
  //   //   getResourcesMenu,
  //   //   dropDownMenuSolution,
  //   //   dropDownMenuFeature,
  //   //   dropDownMenuResources
  //   // )

  //   if (
  //     getSolutionMenu &&
  //     getFeatMenu &&
  //     getResourcesMenu &&
  //     dropDownMenuSolution &&
  //     dropDownMenuFeature &&
  //     dropDownMenuResources
  //   ) {
  //     const solutionClickHandler = (event) => {
  //       // console.log(' HI I AM CLICKED', getSolutionMenu.classList)
  //       event.stopPropagation()
  //       if (getFeatMenu.classList.contains('showDropdown') || getResourcesMenu.classList.contains('showDropdown')) {
  //         getFeatMenu.classList.remove('showDropdown')
  //         getResourcesMenu.classList.remove('showDropdown')
  //       }
  //       getSolutionMenu.classList.add('showDropdown')
  //     }

  //     const featureClickHandler = (event) => {
  //       event.stopPropagation()
  //       if (getSolutionMenu.classList.contains('showDropdown') || getResourcesMenu.classList.contains('showDropdown')) {
  //         getSolutionMenu.classList.remove('showDropdown')
  //         getResourcesMenu.classList.remove('showDropdown')
  //       }
  //       getFeatMenu.classList.add('showDropdown')
  //     }

  //     const resourcesClickHandler = (event) => {
  //       event.stopPropagation()
  //       if (getSolutionMenu.classList.contains('showDropdown') || getFeatMenu.classList.contains('showDropdown')) {
  //         getSolutionMenu.classList.remove('showDropdown')
  //         getFeatMenu.classList.remove('showDropdown')
  //       }
  //       getResourcesMenu.classList.add('showDropdown')
  //     }

  //     const documentClickHandler = (event) => {
  //       if (!dropDownMenuSolution.contains(event.target) && getSolutionMenu.classList.contains('showDropdown')) {
  //         getSolutionMenu.classList.remove('showDropdown')
  //       }
  //       if (!dropDownMenuFeature.contains(event.target) && getFeatMenu.classList.contains('showDropdown')) {
  //         getFeatMenu.classList.remove('showDropdown')
  //       }
  //       if (!dropDownMenuResources.contains(event.target) && getResourcesMenu.classList.contains('showDropdown')) {
  //         getResourcesMenu.classList.remove('showDropdown')
  //       }
  //     }

  //     // Add event listeners
  //     dropDownMenuSolution.addEventListener('click', solutionClickHandler)
  //     dropDownMenuFeature.addEventListener('click', featureClickHandler)
  //     dropDownMenuResources.addEventListener('click', resourcesClickHandler)
  //     document.addEventListener('click', documentClickHandler)

  //     // Cleanup event listeners on unmount
  //     return () => {
  //       dropDownMenuSolution.removeEventListener('click', solutionClickHandler)
  //       dropDownMenuFeature.removeEventListener('click', featureClickHandler)
  //       dropDownMenuResources.removeEventListener('click', resourcesClickHandler)
  //       document.removeEventListener('click', documentClickHandler)
  //     }
  //   }
  // }, [isRenderedMenu]) // Trigger only when the menu is rendered

  return (
    <>
      <div className="headerWrapper">
        <header className="header_area  header_stick nav-black brad48" id="headerarea">
          {currentUrl.includes('/fr/blog/') || currentUrl.includes('/fr/') ? <HelloBarFr /> : null}
          <nav className="navbar navbar-expand-lg menu_center mainsite1">
            <div className="container">
              <div className="site-mast-left">
                <Link to={t(`/`)} className="navbar-brand sticky_logo">
                  <img
                    width="220"
                    height="45"
                    className="d_logo site-logo"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                    alt={site.title}
                  />

                  {/* <img
                    width="220"
                    height="45"
                    className="d_logo site-logo"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1734933277/VantageFit/2024/Asset_1.png"
                    alt={site.title}
                  /> */}
                </Link>
              </div>
              <div className="collapse navbar-collapse justify-content-center vfit-main">
                <div id="menu-main-menu-global" className="navbar-nav menu  ml-auto">
                  <div className="nav-home menu-item nav-item HeaderN" role="menuitem">
                    <ul className="header_menu">
                      <li className="listingMenu menu-soln solution-menu__item">
                        <a className="site-nav-item " onClick={(e) => e.preventDefault()}>
                          <Trans>Solutions</Trans>
                        </a>
                        <ul className="dropdownmenu row solutions" style={{ marginTop: '15px' }}>
                          <li className="col-4 challenges-menu">
                            <div className="dropdown-menu-header">
                              <Trans>Challenges</Trans>
                            </div>
                            <a className="site-nav-item" href={t(`/steps-challenge/`)}>
                              <div className="d-flex align-items-center">
                                <img
                                  className="mb-2"
                                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1699340014/VantageFit/2023/step_challenge.svg"
                                  alt="Steps Challenges"
                                />
                                <div className="ml-4">
                                  <div className="nav-item-heading red-text">
                                    <Trans>
                                      <span>Steps</span> Challenge
                                    </Trans>
                                  </div>
                                  <p className="nav-item-desc">
                                    <Trans>
                                      Promote physical activity and engagement through different step tracking
                                      challenges.
                                    </Trans>
                                  </p>
                                </div>
                              </div>
                            </a>
                            <a className="site-nav-item" href={t(`/multi-activity-challenges/`)}>
                              <div className="d-flex align-items-center">
                                <img
                                  className="mb-2"
                                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/multi_activity_challenge.svg"
                                  alt=" Multi-activity Challenges"
                                />
                                <div className="ml-4">
                                  <div className="nav-item-heading red-text">
                                    <Trans>
                                      <span>Custom</span> Challenges
                                    </Trans>
                                  </div>
                                  <p className="nav-item-desc">
                                    <Trans>
                                      Create custom challenges to support unique wellness goals and workplace culture.
                                    </Trans>
                                  </p>
                                </div>
                              </div>
                            </a>
                            <a className="site-nav-item" href={t(`/team-challenges/`)}>
                              <div className="d-flex align-items-center">
                                <img
                                  className="mb-2"
                                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1699340014/VantageFit/2023/team_challenge.svg"
                                  alt="Team ChalleChallengenges"
                                />
                                <div className="ml-4">
                                  <div className="nav-item-heading red-text">
                                    <Trans>
                                      <span>Team</span> Challenge
                                    </Trans>
                                  </div>
                                  <p className="nav-item-desc mb-0">
                                    <Trans>
                                      Encourage collaboration and healthy competition with team-based wellness
                                      activities.
                                    </Trans>
                                  </p>
                                </div>
                              </div>
                            </a>
                            <a className="site-nav-item" href={t(`/virtual-marathon/`)}>
                              <div className="d-flex align-items-center">
                                <img
                                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1733308256/VantageFit/2024/marathon.png"
                                  alt="Team ChalleChallengenges"
                                />
                                <div className="ml-4">
                                  <div className="nav-item-heading">
                                    <Trans>One Day</Trans>{' '}
                                    <span className="text-red">
                                      <Trans>Virtual Marathon</Trans>
                                    </span>
                                  </div>
                                  <p className="nav-item-desc mb-0">
                                    <Trans>Unite your global workforce through a one-day virtual marathon.</Trans>
                                  </p>
                                </div>
                              </div>
                            </a>
                          </li>
                          <li className="col-8 other-soln-menu">
                            <div className="dropdown-menu-header">
                              <Trans>Other solutions</Trans>
                            </div>
                            <div className="row">
                              <div className="col-6 pl-0">
                                <a className="site-nav-item" href={t(`/remote-team-wellness/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1699340013/VantageFit/2023/remote_team_wellness.svg"
                                    alt="Remote
                                                                                    Team
                                                                                    Wellness"
                                  />
                                  <div className="nav-item-heading">
                                    <Trans>Remote Team Wellness</Trans>
                                  </div>
                                  <p className="nav-item-desc">
                                    <Trans>
                                      Offer wellness solutions that are crafted to meet the unique needs of remote
                                      workforces and their dynamic environments.
                                    </Trans>
                                  </p>
                                </a>
                                <a className="site-nav-item" href={t(`/global-employee-engagement/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1699339980/VantageFit/2023/global_employee_engagement.svg"
                                    alt="Global
                                                                                    Employee
                                                                                    Engagement"
                                  />
                                  <div className="nav-item-heading">
                                    <Trans>Global Employee Engagement</Trans>
                                  </div>
                                  <p className="nav-item-desc">
                                    <Trans>
                                      Implement initiatives that cater to diverse cultural and regional preferences,
                                      fostering a connected global workforce.
                                    </Trans>
                                  </p>
                                </a>
                                <a className="site-nav-item" href={t(`/mental-health-and-wellbeing-challenges/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1699340013/VantageFit/2023/mental_health_and_wellbeing.svg"
                                    alt="Mental
                                                                                    Health
                                                                                    &
                                                                                    Well-being"
                                  />
                                  <div className="nav-item-heading">
                                    <Trans>Mental Health & Well-being</Trans>
                                  </div>
                                  <p className="nav-item-desc mb-0">
                                    <Trans>
                                      Support a work environment that prioritizes mental health with targeted resources
                                      and supportive initiatives.
                                    </Trans>
                                  </p>
                                </a>
                              </div>
                              <div className="col-6 pr-0">
                                <a className="site-nav-item" href={t(`/holistic-wellness-program/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/Holistic.svg"
                                    alt="Holistic
                                                                                    Wellness
                                                                                    Program"
                                  />
                                  <div className="nav-item-heading">
                                    <Trans>Holistic Wellness Program</Trans>
                                  </div>
                                  <p className="nav-item-desc">
                                    <Trans>
                                      Embrace a well-rounded approach to well-being, encompassing multiple dimensions of
                                      a healthy corporate lifestyle.
                                    </Trans>
                                  </p>
                                </a>
                                <a className="site-nav-item" href={t(`/wellness-rewards-program/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360831/VantageFit/2023/wellness_rewards.svg"
                                    alt="Wellness
                                                                                    Rewards
                                                                                    Program"
                                  />
                                  <div className="nav-item-heading">
                                    <Trans>Wellness Rewards Program</Trans>
                                  </div>
                                  <p className="nav-item-desc">
                                    <Trans>
                                      Drive positive health behaviors with a rewards system that celebrates wellness
                                      milestones and achievements.
                                    </Trans>
                                  </p>
                                </a>
                                <a className="site-nav-item" href={t(`/health-fitness-analytics/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/Health_analytics.svg"
                                    alt="Health
                                                                                    &
                                                                                    Fitness
                                                                                    Analytics"
                                  />
                                  <div className="nav-item-heading">
                                    <Trans>Health & Fitness Analytics</Trans>
                                  </div>
                                  <p className="nav-item-desc mb-0">
                                    <Trans>
                                      Utilize analytical insights to track and optimize the corporate wellness programs
                                      and encourage widespread participation.
                                    </Trans>
                                  </p>
                                </a>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="listingMenu menu-soln feature-menu__item">
                        <a className="site-nav-item " onClick={(e) => e.preventDefault()}>
                          <Trans>Features</Trans>
                        </a>
                        <ul className="dropdownmenu row feat">
                          <li className="col-4 challenges-menu feat-left-menu">
                            <div className="dropdown-menu-header">
                              <Trans>Holistic Wellness Trackers</Trans>
                            </div>
                            <a className="site-nav-item" href={t(`/features/activity-tracking/`)}>
                              <div className="d-flex align-items-start justify-content-md-start">
                                <img
                                  className="mb-2 mr-3"
                                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/activity_tracking.svg"
                                  alt="Activity Tracking"
                                />
                                <div className="nav-item-heading">
                                  <span className="text-red">
                                    <Trans>Activity Tracking</Trans>
                                  </span>
                                  <p className="nav-item-desc mb-0">
                                    <Trans>Capture every move, note progress.</Trans>
                                  </p>
                                </div>
                              </div>
                            </a>
                            <a className="site-nav-item" href={t(`/features/nutrition-and-hydration/`)}>
                              <div className="d-flex align-items-start justify-content-md-start">
                                <img
                                  className="mb-2 mr-3"
                                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/Nutrition_and_Hydration.svg"
                                  alt="Nutrition & Hydration"
                                />
                                <div className="nav-item-heading">
                                  <span className="text-red">
                                    <Trans>Nutrition & Hydration</Trans>
                                  </span>
                                  <p className="nav-item-desc mb-0">
                                    <Trans>Fuel, hydrate, repeat.</Trans>
                                  </p>
                                </div>
                              </div>
                            </a>
                            <a className="site-nav-item" href={t(`/features/fitness-and-exercise/`)}>
                              <div className="d-flex align-items-start justify-content-md-start">
                                <img
                                  className="mb-2 mr-3"
                                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Fitness_and_Exercise.svg"
                                  alt="Fitness & Exercise"
                                />
                                <div className="nav-item-heading">
                                  <span className="text-red">
                                    <Trans>Fitness & Exercise</Trans>
                                  </span>
                                  <p className="nav-item-desc mb-0">
                                    <Trans>Your fitness journey, now at your fingertips.</Trans>
                                  </p>
                                </div>
                              </div>
                            </a>
                            <a className="site-nav-item" href={t(`/features/health-metrics/`)}>
                              <div className="d-flex align-items-start justify-content-md-start">
                                <img
                                  className="mb-2 mr-3"
                                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Health_metrics.svg"
                                  alt="Health Metrics"
                                />
                                <div className="nav-item-heading">
                                  <span className="text-red">
                                    <Trans>Health Metrics</Trans>
                                  </span>
                                  <p className="nav-item-desc mb-0">
                                    <Trans>Shape wellness with insightful metrics.</Trans>
                                  </p>
                                </div>
                              </div>
                            </a>
                            <a className="site-nav-item" href={t(`/features/mental-health-and-mindfulness/`)}>
                              <div className="d-flex align-items-start justify-content-md-start">
                                <img
                                  className="mb-2 mr-3"
                                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/mental_wellbeing.svg"
                                  alt="Mental Well-being"
                                />
                                <div className="nav-item-heading">
                                  <span className="text-red">
                                    <Trans>Mental Well-being</Trans>
                                  </span>
                                  <p className="nav-item-desc mb-0">
                                    <Trans>Achieve balance, discover your zen.</Trans>
                                  </p>
                                </div>
                              </div>
                            </a>
                          </li>
                          <li className="col-8 other-soln-menu">
                            <div className="dropdown-menu-header">
                              <Trans>Other Features</Trans>
                            </div>
                            <div className="row">
                              <div className="col-6 pl-0">
                                <a className="site-nav-item d-flex" href={t(`/features/accessibility/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Accessibility.svg"
                                    alt="Accessibility"
                                  />
                                  <div className="ml-4">
                                    <div className="nav-item-heading">
                                      <Trans>Accessibility</Trans>
                                    </div>
                                    <p className="nav-item-desc">
                                      <Trans>
                                        Enable seamless well-being journeys across various devices, languages, and
                                        locations
                                      </Trans>
                                    </p>
                                  </div>
                                </a>
                                <a className="site-nav-item d-flex" href={t(`/features/admin-dashboard/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Admin_Dashboard.svg"
                                    alt="Admin Dashboard"
                                  />
                                  <div className="ml-4">
                                    <div className="nav-item-heading">
                                      <Trans>Admin Dashboard</Trans>
                                    </div>
                                    <p className="nav-item-desc">
                                      <Trans>
                                        Equip wellness coordinators with robust tools for efficient program
                                        administration.
                                      </Trans>
                                    </p>
                                  </div>
                                </a>
                                <a className="site-nav-item d-flex" href={t(`/features/engagement-tools/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Engagement_Tools.svg"
                                    alt="Engagement Tools"
                                  />
                                  <div className="ml-4">
                                    <div className="nav-item-heading">
                                      <Trans>Engagement Tools</Trans>
                                    </div>
                                    <p className="nav-item-desc mb-0">
                                      <Trans>
                                        Cultivate an active community, organize challenges, and commemorate
                                        accomplishments.
                                      </Trans>
                                    </p>
                                  </div>
                                </a>
                                <a className="site-nav-item d-flex" href={t(`/features/incentivization-and-rewards/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412164/VantageFit/2023/Incentivization_Rewards.svg"
                                    alt="Incentivization & Rewards"
                                  />
                                  <div className="ml-4">
                                    <div className="nav-item-heading">
                                      <Trans>Incentivization & Rewards</Trans>
                                    </div>
                                    <p className="nav-item-desc">
                                      <Trans>
                                        Inspiring healthy behaviors with our innovative system of incentives and
                                        rewards.
                                      </Trans>
                                    </p>
                                  </div>
                                </a>
                              </div>
                              <div className="col-6 pr-0">
                                <a className="site-nav-item d-flex" href={t(`/features/integrations/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412164/VantageFit/2023/Integration.svg"
                                    alt="Integration"
                                  />
                                  <div className="ml-4">
                                    <div className="nav-item-heading">
                                      <Trans>Integrations</Trans>
                                    </div>
                                    <p className="nav-item-desc">
                                      <Trans>
                                        Simplify connecting devices, apps, and HR systems for a unified wellness
                                        journey.
                                      </Trans>
                                    </p>
                                  </div>
                                </a>
                                <a className="site-nav-item d-flex" href={t(`/features/security-and-compliance/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/Security_Compliance.svg"
                                    alt="Security & Compliance"
                                  />
                                  <div className="ml-4">
                                    <div className="nav-item-heading">
                                      <Trans>Security & Compliance</Trans>
                                    </div>
                                    <p className="nav-item-desc mb-0">
                                      <Trans>Prioritizing the protection of employee data.</Trans>
                                    </p>
                                  </div>
                                </a>
                                <a className="site-nav-item d-flex" href={t(`/features/wellness-leagues/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1738059656/VantageFit/2025/wellness_league.svg"
                                    alt="Security & Compliance"
                                  />
                                  <div className="ml-4">
                                    <div className="nav-item-heading">
                                      <Trans>Wellness Leagues</Trans>
                                    </div>
                                    <p className="nav-item-desc mb-0">
                                      <Trans>
                                        Segment employees by step data into Bronze, Silver, or Gold Wellness Leagues.
                                      </Trans>
                                    </p>
                                  </div>
                                </a>
                                <a className="site-nav-item d-flex" href={t(`/features/personalized-programs/`)}>
                                  <img
                                    className="mb-2"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1747050611/VantageFit/2025/Personalised_Programs_icon.svg"
                                    alt="Security & Compliance"
                                    width={30}
                                    height={33}
                                  />

                                  <div className="ml-4">
                                    <div className="nav-item-heading">
                                      <Trans>Personalized Program</Trans>
                                    </div>
                                    <p className="nav-item-desc mb-0">
                                      <Trans>
                                        Provide AI-powered wellness solutions designed to fit each employee's unique
                                        needs.
                                      </Trans>
                                    </p>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="">
                        <a className="site-nav-item" href={t(`/pricing/`)}>
                          <Trans>Pricing</Trans>
                        </a>
                      </li>
                      <li className="listingMenu resource-menu__item">
                        <a className="site-nav-item" onClick={(e) => e.preventDefault()}>
                          <Trans>Resources</Trans>
                        </a>
                        <ul className="dropdownmenu resources-menu" style={{ marginTop: '15px' }}>
                          <li>
                            <a aria-current="page" className="site-nav-item " href={t(`/en/blog/`)}>
                              <div className="nav-item-heading">
                                {' '}
                                <Trans>Blog</Trans>
                              </div>
                              <p className="nav-item-desc">
                                <Trans>
                                  Discover valuable insights to enrich your corporate wellness program and stay current
                                  with wellness trends.
                                </Trans>
                              </p>
                            </a>
                          </li>
                          <li>
                            <a aria-current="page" className="site-nav-item" href={t(`/guides/`)}>
                              <div className="nav-item-heading">
                                <Trans>Guides</Trans>
                              </div>
                              <p className="nav-item-desc">
                                <Trans>
                                  Tailored resources for successful wellness program implementation, providing
                                  step-by-step guidance.
                                </Trans>
                              </p>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <a
                  className="menu_cus btn_get btn-meta btn_hover menu-top mr-2 arrowbtn-img"
                  href={t(`/request-demo/`)}
                >
                  <Trans>Request Demo</Trans>
                </a>
                <div className="languageSelect">
                  <button onClick={() => showDropdown()}>
                    <span className="pr-1">
                      <svg className="text-gray-400" viewBox="0 0 24 24" fill="#333" stroke="#333">
                        <path d="M12.02 0c6.614.011 11.98 5.383 11.98 12 0 6.623-5.376 12-12 12-6.623 0-12-5.377-12-12 0-6.617 5.367-11.989 11.981-12h.039zm3.694 16h-7.427c.639 4.266 2.242 7 3.713 7 1.472 0 3.075-2.734 3.714-7m6.535 0h-5.523c-.426 2.985-1.321 5.402-2.485 6.771 3.669-.76 6.671-3.35 8.008-6.771m-14.974 0h-5.524c1.338 3.421 4.34 6.011 8.009 6.771-1.164-1.369-2.059-3.786-2.485-6.771m-.123-7h-5.736c-.331 1.166-.741 3.389 0 6h5.736c-.188-1.814-.215-3.925 0-6m8.691 0h-7.685c-.195 1.8-.225 3.927 0 6h7.685c.196-1.811.224-3.93 0-6m6.742 0h-5.736c.062.592.308 3.019 0 6h5.736c.741-2.612.331-4.835 0-6m-12.825-7.771c-3.669.76-6.671 3.35-8.009 6.771h5.524c.426-2.985 1.321-5.403 2.485-6.771m5.954 6.771c-.639-4.266-2.242-7-3.714-7-1.471 0-3.074 2.734-3.713 7h7.427zm-1.473-6.771c1.164 1.368 2.059 3.786 2.485 6.771h5.523c-1.337-3.421-4.339-6.011-8.008-6.771"></path>
                      </svg>
                    </span>
                    {langSelected}
                  </button>
                  <ul className="languages">
                    {languages.map((lang) => (
                      <li
                        onClick={() => selectLangList(lang)}
                        key={lang}
                        style={{
                          display: cssDisplay,
                        }}
                      >
                        <Link to={lang == `en-US` ? `/` : `/` + lang + `/`} language={lang}>
                          {lang}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Navbar className="navbar-light mobile_navbar mainsite">
                <NavbarBrand href="/" className="mr-auto">
                  <img
                    width="150"
                    height="45"
                    alt="Vantage Fit"
                    className="stick_logo"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                    data-loaded="true"
                  />
                  {/* <img
                    width="150"
                    height="45"
                    alt="Vantage Fit"
                    className="stick_logo"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1734933277/VantageFit/2024/Asset_1.png"
                    data-loaded="true"
                  /> */}
                </NavbarBrand>
                <div className="languageSelect">
                  <button onClick={() => showDropdown()}>
                    <span className="pr-1">
                      <svg className="text-gray-400" viewBox="0 0 24 24" fill="#333" stroke="#333">
                        <path d="M12.02 0c6.614.011 11.98 5.383 11.98 12 0 6.623-5.376 12-12 12-6.623 0-12-5.377-12-12 0-6.617 5.367-11.989 11.981-12h.039zm3.694 16h-7.427c.639 4.266 2.242 7 3.713 7 1.472 0 3.075-2.734 3.714-7m6.535 0h-5.523c-.426 2.985-1.321 5.402-2.485 6.771 3.669-.76 6.671-3.35 8.008-6.771m-14.974 0h-5.524c1.338 3.421 4.34 6.011 8.009 6.771-1.164-1.369-2.059-3.786-2.485-6.771m-.123-7h-5.736c-.331 1.166-.741 3.389 0 6h5.736c-.188-1.814-.215-3.925 0-6m8.691 0h-7.685c-.195 1.8-.225 3.927 0 6h7.685c.196-1.811.224-3.93 0-6m6.742 0h-5.736c.062.592.308 3.019 0 6h5.736c.741-2.612.331-4.835 0-6m-12.825-7.771c-3.669.76-6.671 3.35-8.009 6.771h5.524c.426-2.985 1.321-5.403 2.485-6.771m5.954 6.771c-.639-4.266-2.242-7-3.714-7-1.471 0-3.074 2.734-3.713 7h7.427zm-1.473-6.771c1.164 1.368 2.059 3.786 2.485 6.771h5.523c-1.337-3.421-4.339-6.011-8.008-6.771"></path>
                      </svg>
                    </span>
                    {langSelected}
                  </button>
                  <ul className="languages">
                    {languages.map((lang) => (
                      <li
                        onClick={() => selectLangList(lang)}
                        key={lang}
                        style={{
                          display: cssDisplay,
                        }}
                      >
                        <Link to={lang == `en-US` ? `/` : `/` + lang + `/`} language={lang}>
                          {lang}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <NavbarToggler onClick={toggleNavbar1} className="mr-2" />
                <Collapse isOpen={!collapsed1} navbar>
                  <ul className="mobileheader_menu">
                    <li className="mobile_listing ">
                      <Trans>Solutions</Trans>
                      <ul className="dropdownmenu">
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/steps-challenge/`)}>
                            <Trans>Steps Challenge</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/multi-activity-challenges/`)}>
                            <Trans>Custom Challenges</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/team-challenges/`)}>
                            <Trans>Team Challenge</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/virtual-marathon/`)}>
                            <Trans>One Day Virtual Marathon</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/remote-team-wellness/`)}>
                            <Trans>Remote Team Wellness</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/global-employee-engagement/`)}>
                            <Trans>Global Employee Engagement</Trans>
                          </a>
                        </li>
                        <li>
                          <a
                            aria-current="page"
                            className="site-nav-item"
                            href={t(`/mental-health-and-wellbeing-challenges/`)}
                          >
                            <Trans>Mental Health & Well-being</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/holistic-wellness-program/`)}>
                            <Trans>Holistic Wellness Program</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/wellness-rewards-program/`)}>
                            <Trans>Wellness Rewards Program</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/health-fitness-analytics/`)}>
                            <Trans>Health & Fitness Analytics</Trans>
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="mobile_listing ">
                      <Trans>Features</Trans>
                      <ul className="dropdownmenu">
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/features/activity-tracking/`)}>
                            <Trans>Activity Tracking</Trans>
                          </a>
                        </li>
                        <li>
                          <a
                            aria-current="page"
                            className="site-nav-item"
                            href={t(`/features/nutrition-and-hydration/`)}
                          >
                            <Trans>Nutrition & Hydration</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/features/fitness-and-exercise/`)}>
                            <Trans>Fitness & Exercise</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/features/health-metrics/`)}>
                            <Trans>Health Metrics</Trans>
                          </a>
                        </li>
                        <li>
                          <a
                            aria-current="page"
                            className="site-nav-item"
                            href={t(`/features/mental-health-and-mindfulness/`)}
                          >
                            <Trans>Mental Well-being</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/features/accessibility/`)}>
                            <Trans>Accessibility</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/features/admin-dashboard/`)}>
                            <Trans>Admin Dashboard</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/features/engagement-tools/`)}>
                            <Trans>Engagement Tools</Trans>
                          </a>
                        </li>
                        <li>
                          <a
                            aria-current="page"
                            className="site-nav-item"
                            href={t(`/features/incentivization-and-rewards/`)}
                          >
                            <Trans>Incentivization & Rewards</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/features/integrations/`)}>
                            <Trans>Integrations</Trans>
                          </a>
                        </li>
                        <li>
                          <a
                            aria-current="page"
                            className="site-nav-item"
                            href={t(`/features/security-and-compliance/`)}
                          >
                            <Trans>Security & Compliance</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/features/wellness-leagues/`)}>
                            <Trans>Wellness Leagues</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item" href={t(`/features/personalized-programs/`)}>
                            <Trans>Personalized Program</Trans>
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link className="site-nav-item" to={t(`/features/integrations/`)}>
                        {t(`Pricing`)}
                      </Link>
                    </li>
                    <li className="mobile_listing">
                      <Trans>Resources</Trans>
                      <ul className="dropdownmenu">
                        <li>
                          <a aria-current="page" className="site-nav-item " href={t(`/en/blog/`)}>
                            <Trans>Blog</Trans>
                          </a>
                        </li>
                        <li>
                          <a aria-current="page" className="site-nav-item " href={t(`/guides/`)}>
                            <Trans>Guides</Trans>
                          </a>
                        </li>
                      </ul>
                    </li>
                    {/* <li>
                                            <a
                                                className="site-nav-item"
                                                href="/contact-us/"
                                            >
                                                Contact Us
                                            </a>
                                        </li> */}
                    <li>
                      <a
                        className="menu_cus btn_get btn-meta btn_hover menu-top arrowbtn-img"
                        href={t(`/request-demo/`)}
                      >
                        <Trans>Book a Demo</Trans>
                      </a>
                    </li>
                  </ul>
                </Collapse>
              </Navbar>
            </div>
          </nav>
        </header>
      </div>
    </>
  )
}

// HeaderFr.propTypes = {
//     children: PropTypes.node.isRequired,
//     bodyclassName: PropTypes.string,
//     isHome: PropTypes.bool,
//     data: PropTypes.shape({
//         file: PropTypes.object,
//         allGhostSettings: PropTypes.object.isRequired,
//     }).isRequired,
// };

// const HeaderFrQuery = (props) => (
//     <StaticQuery
//         query={graphql`
//             query GhostSettings {
//                 allGhostSettings {
//                     edges {
//                         node {
//                             ...GhostSettingsFields
//                         }
//                     }
//                 }
//             }
//         `}
//         render={(data) => <HeaderFr data={data} {...props} />}
//     />
// );

export default HeaderFr
